import React from 'react';

import { ButtonMenuItem, LinkMenuItem, MenuList } from '@atlaskit/navigation-system';

import type { Action } from '../types';

/**
 * Component that renders a list of action items for the ObjectListFlyout
 */
export function ActionsList({ items }: { items: Action[] }) {
	return (
		<MenuList>
			{items.map(({ elemBefore, label, href, target, onClick }, index) =>
				href ? (
					<LinkMenuItem
						key={`action-link-${index}`}
						target={target}
						elemBefore={elemBefore}
						href={href}
					>
						{label}
					</LinkMenuItem>
				) : (
					<ButtonMenuItem key={`action-button-${index}`} elemBefore={elemBefore} onClick={onClick}>
						{label}
					</ButtonMenuItem>
				),
			)}
		</MenuList>
	);
}
